//#region [IMPORT]

// === THIRD-PARTY ===
import React, { createContext, useEffect, useState } from 'react';

// === STYLE / MATERIAL UI ===
import { useTheme } from '@mui/material/styles';
import {
  Tooltip,
  Button,
} from '@mui/material';

import {
  Cancel,
} from '@mui/icons-material';

// === HOOKS ===
import { useTaskStatus } from 'components/hooks/useTaskStatus/index';

// === API ===
import { returnTask, setTaskMonitoring } from 'api/prokey/prokey.websocket';

//#endregion

//-----------------------------------------------------------------
export function CancelTaskButton() {
  //-----------------------------------------------------------------

  //#region [VALUES]

  const theme  = useTheme();
  const status = useTaskStatus(); 

  const _styles = {
    submit: {
      height : '40px',
      margin : '0 0.5rem',
    }
  }

  //#endregion

  //#region [DISPLAY]

  //-----------------------------------------------------------------
  function display() {
    //-----------------------------------------------------------------
    return (
      <Tooltip title='Cancel Task'>
        <Button
          name='cancel_task_btn'
          sx={_styles.submit}
          variant='contained'
          color='error'
          disabled ={!status?.can_cancel}
          component={!status?.can_cancel ? "div" : undefined}
          onClick={ () => { returnTask('MANUAL'); setTaskMonitoring(false); } }
        >
          <Cancel />
        </Button>
      </Tooltip>
    );
  };

  //#endregion

  return display();
}
